import { makeStyles } from "@material-ui/core"
import { themeColors } from "letalkui"

const useStyles = makeStyles(() => ({
	iconContainer: {
		width: "40px",
		height: "40px",
		borderRadius: "10px",
		backgroundColor: themeColors.colors.system.purple[100],
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		color: themeColors.colors.system.purple[600]
	},
	profileEyebrow: {
		fontSize: "0.7rem",
		fontWeight: 700,
		color: themeColors.colors.system.gray[500],
		textTransform: "uppercase",
		letterSpacing: "0.05em"
	},
	profileHeading: {
		fontSize: "1.5rem",
		fontWeight: 700,
		color: themeColors.colors.system.gray[900]
	},
	profilePillsRow: {
		display: "flex",
		flexWrap: "wrap",
		gap: "8px"
	},
	profilePillIcon: {
		color: "inherit",
		marginLeft: "4px"
	},
	segmentedPillSelected: {
		backgroundColor: themeColors.colors.system.purple[600],
		color: themeColors.colors.base.white,
		borderRadius: "999px",
		fontSize: "0.75rem",
		fontWeight: 600,
		padding: "4px 12px",
		border: `1px solid ${themeColors.colors.system.purple[600]}`
	},
	segmentedPillUnselected: {
		backgroundColor: themeColors.colors.system.gray[100],
		color: themeColors.colors.system.gray[700],
		borderRadius: "999px",
		fontSize: "0.75rem",
		fontWeight: 500,
		padding: "4px 12px",
		border: "none"
	}
}))

export default useStyles
